import { RestResponse } from '../types/response/RestResponse';
import service from './RestService';
import { Notification, NotificationType, RequestNotificationType } from '../state/notifications/types';

const path = '/notifications';

class NotificationsService {
  getNotifications = (read: boolean): RestResponse<Notification[]> => service.get(`${path}/my`, { read });

  markNotificationsAsRead = (notificationIds: string): RestResponse<Notification[]> => service.post(`${path}/mark-as-read/${notificationIds}`);

  getNotificationType = (): RestResponse<NotificationType[]> => service.get(`${path}/types`);

  saveNotificationType = (notificationType: RequestNotificationType): RestResponse<any> =>
    service.post(`${path}/notification-type-by-user-config`, notificationType);
}

export default new NotificationsService();
